var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "check-list-dialog" },
    [
      _c(_setup.LfBlueTitleComponent, { attrs: { title: _setup.texts.title } }),
      _c(
        "div",
        { staticClass: "step-wizard-container" },
        [
          _c("div", { staticClass: "step-instructions" }, [
            _vm._v(" " + _vm._s(_setup.texts.caption) + " "),
          ]),
          _c(_setup.LfErrorListComponent, {
            attrs: {
              errors: _setup.errorMessages,
              description: _setup.texts.body,
              icon: _setup.icon,
            },
          }),
          _c(
            "div",
            { staticClass: "dialog-actions-container" },
            [
              _c(_setup.LfActionsBarComponent, {
                staticClass: "action-buttons",
                attrs: { showKebabMenu: false, buttons: _setup.buttons },
                on: { "execute-action": _setup.close },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }